import React from 'react';
import PayingAccountDF from '../components/SimulatorsComponents/DefualtSimulators/PayingAccountDF';
import { getSubCategoryId } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_C02_AccountInfoBalance = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <PayingAccountDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    withThreeCard
    isAccountBalanceService
    accountInfo={globJSON.configurations.services[getSubCategoryId(globJSON.screens[selectedScreen])].balance}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_C02_AccountInfoBalance;
